export default __webpack_public_path__ + "static/media/hospital2.75242343.svg";